import React from 'react';
import BackupPanel from '../../components/admin/BackupPanel';

const BackupPage: React.FC = () => {
  return <BackupPanel />;
};

export default BackupPage;
